import { authenticatedFetchJson } from "@/lib/authenticatedFetch";
import { V2_ENDPOINT } from "@/consts";

export interface TableInfo {
  name: string;
}

export interface ColumnInfo {
  name: string;
  type: string;
  notNull: boolean;
  defaultValue: unknown;
  primaryKey: boolean;
}

export interface QueryResult {
  rows: Record<string, unknown>[];
  rowsAffected: number;
}

interface ApiSuccessResponse<T> {
  code: 0;
  data: T;
  message: string;
  requestId: string;
}

export async function listTables(orgId: string): Promise<ApiSuccessResponse<{ tables: TableInfo[] }>> {
  return authenticatedFetchJson(`${V2_ENDPOINT}/v1/organizations/${orgId}/database/tables`);
}

export async function getTableSchema(
  orgId: string,
  tableName: string,
): Promise<ApiSuccessResponse<{ columns: ColumnInfo[] }>> {
  return authenticatedFetchJson(
    `${V2_ENDPOINT}/v1/organizations/${orgId}/database/tables/${encodeURIComponent(tableName)}`,
  );
}

export async function executeQuery(
  orgId: string,
  sql: string,
  params?: unknown[],
): Promise<ApiSuccessResponse<QueryResult>> {
  return authenticatedFetchJson(`${V2_ENDPOINT}/v1/organizations/${orgId}/database/query`, {
    method: "POST",
    body: JSON.stringify({ sql, params: params ?? [] }),
  });
}
